/**
 * Osteo3d brand logo — same component + asset as apps/portal.
 * Source image: public/osteo3d-logo.png
 */
const HEIGHT = { sm: 36, md: 52, lg: 72 }

export default function OsteoLogo({ size = 'md' }) {
  const h = HEIGHT[size] ?? HEIGHT.md
  return (
    <img
      src="/osteo3d-logo.png"
      alt="Osteo3d — 3d printing healthcare"
      height={h}
      style={{ height: h, width: 'auto', display: 'block' }}
    />
  )
}
